import { render, staticRenderFns } from "./RatingEdit.vue?vue&type=template&id=6db4239b&scoped=true&"
import script from "./RatingEdit.vue?vue&type=script&lang=js&"
export * from "./RatingEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db4239b",
  null
  
)

export default component.exports